/** @jsx jsx */
import { useEffect } from 'react';
import FormContents from 'components/atoms/Form/FormContents';
import moment from 'moment';
import PrimaryButton from 'components/atoms/Button';
import ConfirmModal from 'components/organismos/ConfirmModal';
import BlockUI from 'components/molecules/BlockUi';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';
import { css, jsx } from '@emotion/core';
import { useSalesBudgetMonth } from './hooks';
import TableSalesPlanDaily from './TableSalesPlanDaily';

const SalesBudgetDailyInputLayout = () => {
  const {
    isLoading,
    getRows,
    formik,
    handleChangeSelect,
    calcSalesRatioValues,
    confirmModalOpen,
    closeConfirmModal,
    calcLtSalesDailyValues,
    calcLtCostDailyValues,
    calcLtLaborDailyValues,
    calcLtAdvertisingDailyValues,
    calcLtRentDailyValues,
    calcLtExpensesDailyValues,
    calcLtOtherDailyValues,
    calcLtCustomPriceDailyValues,
    calcLtSalesMonthlyValue,
    calcLtCostMonthlyValue,
    calcLtLaborMonthlyValue,
    calcLtAdvertisingMonthlyValue,
    calcLtRentMonthlyValue,
    calcLtExpensesMonthlyValue,
    calcLtOtherMonthlyValue,
    calcLtCustomPriceMonthlyValue,
  } = useSalesBudgetMonth();
  const history = useHistory();

  const orgCode = sessionStorage.getItem('orgCode_DestinationOrg') || '';

  const roleScreen = useSelector((state: Store) => state.auth.roleScreen);

  const staffAccess =
    roleScreen &&
    roleScreen.useStaffAccess === true &&
    roleScreen.staffAccessFunctionRoles.filter((role: any) => role.orgCode === orgCode);

  const checkUserRole = staffAccess && staffAccess.length > 0 ? staffAccess[0] : roleScreen;

  useEffect(() => {
    if (checkUserRole && checkUserRole.available === false) {
      history.push('/404');
    }
  }, [checkUserRole, history]);

  const orgName = sessionStorage.getItem('destination_org');
  const targetMonth = sessionStorage.getItem('month_selected');
  const handleBack = () => {
    history.push('/salesBudgetYearInput');
    sessionStorage.setItem('isBack', 'true');
  };

  return (
    <div className="sales_budget_month">
      <BlockUI blocking={isLoading}>
        <FormContents>
          <div
            css={css({
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 32,
            })}
          >
            <p>
              対象年月：
              {moment(targetMonth?.toString()).format('YYYY年MM月')}
            </p>
            <p>
              組織名：
              {orgName}
            </p>
          </div>
          <TableSalesPlanDaily
            formik={formik}
            getRows={getRows}
            handleChangeSelect={handleChangeSelect}
            calcSalesRatioValues={calcSalesRatioValues}
            calcLtSalesDailyValues={calcLtSalesDailyValues}
            calcLtCostDailyValues={calcLtCostDailyValues}
            calcLtLaborDailyValues={calcLtLaborDailyValues}
            calcLtAdvertisingDailyValues={calcLtAdvertisingDailyValues}
            calcLtRentDailyValues={calcLtRentDailyValues}
            calcLtExpensesDailyValues={calcLtExpensesDailyValues}
            calcLtOtherDailyValues={calcLtOtherDailyValues}
            calcLtCustomPriceDailyValues={calcLtCustomPriceDailyValues}
            calcLtSalesMonthlyValue={calcLtSalesMonthlyValue}
            calcLtCostMonthlyValue={calcLtCostMonthlyValue}
            calcLtLaborMonthlyValue={calcLtLaborMonthlyValue}
            calcLtAdvertisingMonthlyValue={calcLtAdvertisingMonthlyValue}
            calcLtRentMonthlyValue={calcLtRentMonthlyValue}
            calcLtExpensesMonthlyValue={calcLtExpensesMonthlyValue}
            calcLtOtherMonthlyValue={calcLtOtherMonthlyValue}
            calcLtCustomPriceMonthlyValue={calcLtCustomPriceMonthlyValue}
          />
        </FormContents>
        <div
          css={css({
            display: 'flex',
            flexDirection: 'row',
            gap: 8,
            justifyContent: 'center',
            margin: '12px 0',
          })}
        >
          {checkUserRole && checkUserRole.editable === 1 && (
            <span>
              <PrimaryButton onClick={formik.handleSubmit} text="更新 " />
            </span>
          )}
          <span>
            <PrimaryButton onClick={handleBack} text="戻る " />
          </span>
        </div>
      </BlockUI>

      <ConfirmModal
        title="確認メッセージ"
        content="更新します。よろしいですか？"
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        onSubmit={formik.submitForm}
        submitText="更新"
        items={[]}
      />
    </div>
  );
};
export default SalesBudgetDailyInputLayout;
